import moment from "moment";

export const ViewRequisitionTabsArr = [
  { label: "Open", value: 1 },
  { label: "Completed", value: 3 },
  { label: "Rejected", value: 4 },
  { label: "Deleted", value: 5 },
  { label: "On Hold", value: 2 },
  { label: "All Requisition", value: 0 },
];

export const ResultDataTabsArr = [
  { label: "Panding", value: 1 },
  { label: "Completed", value: 3 },
  { label: "Archived", value: 5 },
];

export const BulkActionArr = {
  StatusArr: [
    { label: "Completed", dropDownValue: "dropdown1", bulkStatus: 3 },
    { label: "Deleted", dropDownValue: "dropdown1", bulkStatus: 5 },
    { label: "On Hold", dropDownValue: "dropdown1", bulkStatus: 2 },
    { label: "Rejected", dropDownValue: "dropdown1", bulkStatus: 4 },
  ],
  PrintArr: [
    { label: "Print Selected Label", dropDownValue: "dropdown1" },
    { label: "Print Selected Records", dropDownValue: "dropdown1" },
    { label: "Print Selected Reports", dropDownValue: "dropdown1" },
  ],
};

const getRowValueByColumnKey = (rowsData: any, columnKey: string) => {
  if (!rowsData || !columnKey) return undefined;
  const normalizedKey = Object.keys(rowsData).find(
    (k) => k.toLowerCase() === columnKey.toLowerCase()
  );
  return normalizedKey ? rowsData[normalizedKey] : undefined;
};

export const dateFormatConversion = (RowsData: any, columnKey: string) => {
  const columnValue = getRowValueByColumnKey(RowsData, columnKey);
  const columnKeyLower = columnKey?.toLowerCase();

  if (
    columnKeyLower === "addeddate" ||
    columnKeyLower === "validatedate" ||
    columnKeyLower === "dob" ||
    columnKeyLower === "receiveddate" ||
    columnKeyLower === "publisheddate" ||
    columnKeyLower === "dateofcollection" ||
    columnKeyLower === "rejecteddate" ||
    columnKeyLower === "collectiondate" ||
    columnKeyLower === "recollectdate" ||
    columnKeyLower === "createddate"
  ) {
    if (columnValue) {
      return moment(columnValue).format("MM/DD/YYYY");
    }
    return "";
  }

  return columnValue;
};
